import { SearchOperationBuilder, SearchParam } from 'wherecomposer/dist/SearchParam';
import { ConditionCreator } from 'wherecomposer/dist/ConditionCreator';
import { getAccount } from '../graphql/account';
import { Auth, API, graphqlOperation, Amplify } from 'aws-amplify';

let accountAppSyncUrl = process.env.REACT_APP_ACCOUNT_APPSYNC_URL;
let accountApiKey = process.env.REACT_APP_ACCOUNT_API_KEY;

const getAccountData = async () => {
    let languageGuid = localStorage.getItem('languageGuid');
    let languageCode = localStorage.getItem("languageCode");

    try {
        let lstobjSearchParam = [];
        let objSearchParam = new SearchParam();
        objSearchParam.searchParamCreate("LanguageGuid", "Guid", languageGuid, SearchOperationBuilder.create(true, false, false));
        lstobjSearchParam.push(objSearchParam);
        let objCreator = new ConditionCreator();
        let objWhere = objCreator.getSearchCondition(lstobjSearchParam);

        const accountConfig = {
            API: {
                'graphql_endpoint': accountAppSyncUrl,
                graphql_headers: async () => {
                    const currentSession = await Auth.currentSession();
                    return {
                        'Authorization': currentSession.getIdToken().getJwtToken(),
                        'language': languageCode,
                        'x-api-key': accountApiKey
                    };
                }
            }
        }

        Amplify.configure(accountConfig);

        return await API.graphql(graphqlOperation(getAccount, { OperationList: objWhere.toJsonString() }));
    } catch (error) {
        console.log('getAccountData error', error);
    }
}

export {
    getAccountData,
}